<script lang="ts">
  import { CardBody, Col, Table } from "sveltestrap";
  import product from "../../../Data/ComponentData/WidgetData/Genral/ProductCart.json";
  import { PRODUCTSCART } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
</script>

<Col xl="6" class="xl-100 box-col-12">
  <Card
    cardHeaderprops="pb-0 d-flex justify-content-between align-items-center"
    headerTitle={PRODUCTSCART}
  >
    <div slot="contentbody">
      <div class="user-status table-responsive">
        <Table borderless>
          <thead>
            <tr>
              {#each product.productheader as header}
                <th scope="col">{header.title}</th>
              {/each}
            </tr>
          </thead>
          <tbody>
            {#each product.Productcartdata as productItem}
              <tr>
                <td class="f-w-600">{productItem.detail}</td>
                <td>{productItem.Quantity}</td>
                <td class={productItem.fontColor}>{productItem.Status}</td>
                <td>
                  <div class="span badge rounded-pill {productItem.color}">
                    {productItem.Price}
                  </div>
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    </div>
  </Card>
</Col>
